import { MediaBlock as MediaBlockType } from '@/payload-types'
import { ImageComponent } from './imageComponent'
import { CaptionComponent } from './caption'
import Link from 'next/link'
import VideoWrapper from './VideoWrapper'
interface IProps {
  mediaData: MediaBlockType
  showCaption?: boolean
  timeStampValue?: string
}

export const MediaComponent = ({ mediaData, showCaption = true, timeStampValue }: IProps) => {
  if (typeof mediaData.media === 'object') {
    const curMedia = mediaData.media

    if (!curMedia) return

    let mediaType = curMedia.mimeType
    mediaType = mediaType?.startsWith('image/')
      ? 'image'
      : mediaType?.startsWith('video/') || !!curMedia.mux?.status
      ? 'video'
      : mediaType?.startsWith('audio/')
      ? 'audio'
      : mediaType

    const ImageComponentRender = (
      <ImageComponent
        src={`${process.env.NEXT_PUBLIC_PAYLOAD_URL ?? ''}${
          mediaData.media.sizes?.webp?.url
        }`}
        alt={mediaData.altText ? mediaData.altText : mediaData.media.title}
        width={mediaData.media.sizes?.webp?.width}
        height={mediaData.media.sizes?.webp?.height}
      />
    )
    return (
      <>
        {(() => {
          switch (mediaType) {
            case 'image':
              return (
                <figure>
                  {mediaData.link ? (
                    <Link href={mediaData.link} target="_blank" prefetch={false}>
                      {ImageComponentRender}
                    </Link>
                  ) : (
                    <>{ImageComponentRender}</>
                  )}
                </figure>
              )
            case 'video':
              return <VideoWrapper mediaData={curMedia} timeStamp={timeStampValue} />
            case 'audio':
              return (
                <audio
                  src={`${
                    process.env.NEXT_PUBLIC_PAYLOAD_URL ? process.env.NEXT_PUBLIC_PAYLOAD_URL : ''
                  }${curMedia.url}`}
                  controls
                  className="w-full py-2"
                />
              )
            default:
              return null
          }
        })()}
        {showCaption && mediaData.caption && <CaptionComponent captionData={mediaData.caption} />}
      </>
    )
  }
}

export default MediaComponent
